import { render, staticRenderFns } from "./SetDraw.vue?vue&type=template&id=797c4c0d&scoped=true&"
import script from "./SetDraw.vue?vue&type=script&lang=js&"
export * from "./SetDraw.vue?vue&type=script&lang=js&"
import style0 from "./SetDraw.vue?vue&type=style&index=0&id=797c4c0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c4c0d",
  null
  
)

export default component.exports